import { Component, ViewChild, TemplateRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApidataService } from "../apidata.service";
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms'; 
import {NgbModal}   from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-save-file',
  standalone: true,
  imports: [CommonModule,

    FormsModule,],
  templateUrl: './save-file.component.html',
  styleUrl: './save-file.component.css'
})
export class SaveFileComponent {
  file_name;
  docTitle = "";
  saveFileText = "";
  validation: string = "";
  savefiletext: string = "";
  profile_id = "";
  notlogin: boolean = false;
  savefiletextsonly: string = '';
  activePopup: string | null = null;
  assistantVisible = true;
  nothingtocheck: boolean = true;
  doc_id = "";
  editorState = {
    doc_id: this.router.url.split('/').pop(),
  }

  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
   )  {
    this.assistantVisible = true;
    this.nothingtocheck = true
    this.profile_id = localStorage.getItem("profile_id");
  

    if(!this.profile_id){
      this.profile_id = '1';
    }

    if(this.profile_id == '1' || this.profile_id == null){
      this.notlogin = false;
    }
    else{
      this.notlogin = true;
    }
   
    }
  ngOnInit() {

    this.openModal();

  }

  @ViewChild('content', { static: true }) content: TemplateRef<any>;
  openModal() {

    this.modalService.open(this.content,{ backdrop: 'static', keyboard: false , centered: true,windowClass: 'my-class'});
  }
  closeModal(){
    this.modalService.dismissAll();
  }
  public clearsavebtnk() {
    this.file_name = $("#file_name").val();
    if (this.file_name === this.docTitle) {
      this.file_name = this.docTitle
    }
    else {
      this.file_name = '';
      if (!this.file_name) {
        this.file_name = this.docTitle
      }
    }
  }
  public saveFile(event: any) {

    if (this.file_name.length > 0) {
      this.savefiletext = "";
    }
  }
  public auto_Saved_for_Modal() {
  
    if (this.docTitle.trim() === '') {
      this.docTitle = 'Grammar Checker - (Grammar Editor)';
    }

    if (!this.file_name || this.file_name.trim() === '') {
      this.file_name = this.docTitle;  
    }

    this.docTitle = this.file_name;
    var content = $('#mm').text();
   
    var saved_from = 'editor';

  
    if (!content || content.trim() === '') {
      // console.error('Content is empty or not found.');
      this.validation = "Document Content is empty!";
      $("#validation").show();
      setTimeout(() => {
        $("#validation").hide();
      }, 3000);
      return;
    }

    this.apiservice.auto_saved_Api1(
      this.profile_id,
      this.file_name,
      this.docTitle,
      content,
      this.editorState.doc_id,
      saved_from
    ).subscribe(data => {
      if (this.file_name !== 'Grammar Checker - (Grammar Editor)') {
        localStorage.setItem('docTitle_' , this.docTitle);
        // console.log(this.docTitle,"this.docTitle")
      }
      
      this.savefiletext = "A new file is created successfully!";
      this.savefiletextsonly = "Saved";
      $("#savefiletext").show();
      setTimeout(() => {
        $("#savefiletext").hide();
        $("#file_name").html('Grammar Checker - (Grammar Editor)');
      }, 3000);

      $("#savefiletextsonly").show();
    });
    $("#file_name").html('Grammar Checker - (Grammar Editor)');
    setTimeout(() => {
      this.modalService.dismissAll();
    }, 3000);
    
   
  }

  
}
